import PagePlaceholder from '@/components/PagePlaceholder';

export default function DataAnalyticsPage() {
  return (
    <PagePlaceholder
      title="Data & Analytics"
      subtitle="Transform your data into structured, searchable and actionable intelligence."
    />
  );
}